import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/common/icon-help.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "p-recommend-form__icon-1",
  src: _imports_0,
  alt: "?",
  width: "48",
  height: "48"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-3" }, [
  /*#__PURE__*/_createTextVNode(" 履歴書、職務経歴書の "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("レジュメ出力項目です。 ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "OK", -1)
const _hoisted_4 = [
  _hoisted_3
]

import { onBeforeUnmount, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumeOutputModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["update:isOpen"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:isOpen', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean
}





const close = () => {
  emit('update:isOpen', false);
};

const handleKeyDown = (event: KeyboardEvent) => {
  if (event.key === 'Escape' || event.key === 'Esc') {
    close();
  }
};

// Watch for changes to isOpen prop to add/remove event listener
watch(() => props.isOpen, (newValue) => {
  if (newValue) {
    // Add event listener when modal opens
    document.addEventListener('keydown', handleKeyDown);
  } else {
    // Remove event listener when modal closes
    document.removeEventListener('keydown', handleKeyDown);
  }
});

// Clean up event listener when component is unmounted
onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-recommend-form__modal js-modal-container", { 'is-active': __props.isOpen }])
  }, [
    _createElementVNode("div", { class: "p-recommend-form__modal-card -is-help" }, [
      _createElementVNode("button", {
        class: "p-recommend-form__modal-help-close js-modal-close-trigger",
        type: "button",
        onClick: close
      }, "閉じる"),
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("button", {
        class: "p-recommend-form__modal-help-close-2 js-modal-close-trigger",
        type: "button",
        onClick: close
      }, _hoisted_4)
    ]),
    _createElementVNode("div", {
      class: "p-recommend-form__modal-close-area js-modal-close-trigger",
      onClick: close
    })
  ], 2))
}
}

})